import { useNationalSiteContext, useLocation } from 'app/common/hooks';
import { isEmpty } from 'lodash';

/**
 * Build the image content URL to be relative to the current origin.
 * @param imageContent An image content item with a contentUrl property.
 * @returns {string|null} The image content URL relative to the current domain.
 */
export function handleImageContent(imageContent) {
  if (!imageContent) {
    return null;
  }

  const contentUrl = imageContent.contentUrl;
  if (contentUrl.includes('myaurora')) {
    return contentUrl.replace('http:', 'https:').replace('testing.', 'test.');
  }

  // contextInfo params are required
  let params = contentUrl.split('?');
  return `${window.location.origin}/api/asset/content${imageContent.url}?${params[1]}`;
}

export function useDetermineEFlyerThemeApplication() {
  const natlSiteContext = useNationalSiteContext();

  const natlOrNetworkNotPtg =
    natlSiteContext.nationalSiteOrDealerNetworkContext &&
    !natlSiteContext.partsToGo &&
    !isEmpty(natlSiteContext.defaultApplication);

  return natlOrNetworkNotPtg
    ? natlSiteContext.defaultApplication
    : natlSiteContext.currentApplication;
}
